import { useAppSelector } from "redux/hooks";

const usePassAdminSifre = (): boolean => {
  const { userOtp } = useAppSelector((state) => state.otp);
  const isNextScreensAdmin = userOtp?.NextScreens?.includes("S") as boolean; //||
  // (userOtp?.NextScreens?.includes("G") as boolean);
  const isPassAdminSifre: boolean = isNextScreensAdmin;

  return isPassAdminSifre;
};

const usePassAdminGuvenlik = (): boolean => {
  const { userOtp } = useAppSelector((state) => state.otp);
  const isNextScreensAdmin =
    // (userOtp?.NextScreens?.includes("S") as boolean) ||
    userOtp?.NextScreens?.includes("G") as boolean;
  const isPassAdminGuvenlik: boolean = isNextScreensAdmin;

  return isPassAdminGuvenlik;
};

export { usePassAdminSifre, usePassAdminGuvenlik };
